<section class="mt-28 px-4">
  <div class="container mx-auto">
    <div
      class="relative overflow-hidden rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 px-8 py-16 md:px-16 md:py-20 text-center"
    >
      <!-- Background pattern -->
      <div class="absolute inset-0 opacity-10">
        <div
          class="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white"
        ></div>
        <div
          class="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-white"
        ></div>
      </div>

      <div class="relative z-10 max-w-2xl mx-auto">
        <div
          class="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-6"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            />
          </svg>
          No Credit Card Required
        </div>
        <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Try For Free First
        </h2>
        <p class="text-lg md:text-xl text-white/90 mb-8 max-w-lg mx-auto">
          Try our premium features for free for 30 days first before you commit
        </p>
        <a
          href="/apply"
          class="inline-flex items-center gap-2 bg-white text-green-600 font-bold text-lg px-10 py-4 rounded-full transition-all duration-300 hover:shadow-xl hover:scale-105"
        >
          Apply to Join Free
          <svg
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</section>
